export default {
  state: {
    appName: "yxvue", // 应用名称
    appCode:"yxvue",
    subName: "", // 应用名称
    secName: "", // 应用名称

    routeLoaded: false, // 菜单和路由是否已经加载
    menuLoaded: false, // 菜单和路由是否已经加载
    serverName: process.env.BASE_API, //"http://192.168.0.163:8080/thdemo",//测试服务器地址 别删 别删 别删 别删 别删 别删
    downloadAddress: process.env.DOWNLOAD_API, //"http://192.168.0.163:8080/thdemo",//测试服务器地址 别删 别删 别删 别删 别删 别删
    reportAddress: process.env.REPORT_API, //"http://192.168.0.163:8080/thdemo",//测试服务器地址 别删 别删 别删 别删 别删 别删
    token: "",
  },
  getters: {

  },
  mutations: {

    setMenuLoaded(state, menuLoaded) { // 改变菜单和路由的加载状态
      state.menuLoaded = menuLoaded
    },
    setRouteLoaded(state, routeLoaded) { // 改变菜单和路由的加载状态
      state.routeLoaded = routeLoaded
    },
    setToken(state, token) {
      state.token = token
    },
    setSecName(state, secName) {
      state.secName = secName
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js